import Analytics from 'helpers/analytics';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { useEffect, useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { postNewCampaignSettings } from 'Views/Campaigns/services/CampaignServices';

export interface IFormSettingsProps {
	name: string;
	type: string;
	questionnaireIds: string[];
}

export interface INewCampaignSettingsProps {
	items: any[];
	onClose: () => void;
	onContinue: (id: string) => void;
}

export const useNewCampaignSettings = (onContinue: any, items: any) => {
	const { getSessionStorage } = useSessionStorage();
	const sessionStorage: any = getSessionStorage('me');
	const user = JSON.parse(sessionStorage);
	const [isModalWarningVisible, setModalWarningVisible] =
		useState<boolean>(false);
	const [isLoading, setLoading] = useState<boolean>(false);
	const [hasError, setError] = useState<boolean>(false);
	const [initialChecked, setInitialChecked] = useState<string[]>([]);
	const [formSettings, setFormSettings] = useState<IFormSettingsProps>({
		name: '',
		type: 'NOM035',
		questionnaireIds: [],
	});

	const checkRequiredField = (state: boolean, value: string) => {
		if (!state && initialChecked.includes(value)) {
			setModalWarningVisible(true);
		}
	};

	const handleCheckbox = (state: boolean, value: string) => {
		const { questionnaireIds } = formSettings;

		checkRequiredField(state, value);

		const hasQuestionnaireId = questionnaireIds.includes(value);

		if (hasQuestionnaireId) {
			const newArrQuestionnaire = questionnaireIds.filter(
				(questionnaire) => questionnaire !== value,
			);
			setFormSettings({
				...formSettings,
				questionnaireIds: newArrQuestionnaire,
			});
		} else {
			questionnaireIds.push(value);
			setFormSettings({ ...formSettings, questionnaireIds });
		}
	};

	const handleSubmit = async () => {
		if (!formSettings.name || !formSettings.questionnaireIds.length) {
			setError(true);
			return;
		}

		try {
			setLoading(true);
			const { data } = await postNewCampaignSettings(formSettings);
			const id = data?.content?.id;

			Analytics.track('campaign', 'create-new-campaign', {
				name: formSettings.name,
				questionnaireIds: formSettings.questionnaireIds,
			});
			onContinue(`${id}?name=${window.btoa(formSettings.name)}`);
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'campaign',
				location: 'postNewCampaignSettings',
				payloadRequest: formSettings,
			});
		} finally {
			setLoading(false);
		}
	};

	const getFormNumber = (formAmount: number) => {
		const formNumber = 'I';

		return formNumber.repeat(formAmount + 1);
	};

	useEffect(() => {
		const questionnaireArr = [];
		for (const index in items) {
			if (items[index].required) questionnaireArr.push(items[index].id);
		}
		setInitialChecked([...questionnaireArr]);
		setFormSettings({ ...formSettings, questionnaireIds: questionnaireArr });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isModalWarningVisible,
		isLoading,
		hasError,
		formSettings,
		user,
		setFormSettings,
		setModalWarningVisible,
		getFormNumber,
		handleSubmit,
		handleCheckbox,
	};
};
